module.exports = __webpack_public_path__ + "static/media/upload-icon.00aaa434.svg";